<div class="media-card">
    <span class="drag-icon">
        <!-- <span class="drag-icon example-handle" cdkDragHandle> -->
        <img src="assets/images/drag-icon.svg" alt="">
    </span>
    <div class="card-top">
        <div class="card-head">
            <span class="subproduct-title"
                *ngIf="cardName=='monitoring'">{{_listData.scoreName?_listData.scoreName:'Score'}}</span>
            <span class="subproduct-title"
                *ngIf="cardName=='benchmarking'">{{_listData['peers']?_listData['peers']:'Score'}}</span>
            <a href="javascript:void(0)" class="info-link" (click)="forPopupOpen(index)"><img
                    src="assets/images/info-icon.svg" alt="info"></a>

            <app-editCard [cardName]="cardName"
                [listData]="_listData" [index]="index" *ngIf="currentPopUp && currentPopUp == index"
                (closePopEvent)="closePopUp()" (valueChange)="valueChangeEvent($event)">
            </app-editCard>
            <span class="feature-subtitle"
                *ngIf="cardName=='benchmarking'">{{_listData.scoreName?_listData.scoreName:'AQI'}}</span>
        </div>
        <div class="card-graph">
            <app-gauge [listData]="_listData" [typeKpi]="_listData.raw" [pageTab]="pageTab" [type]="'card'" [cardUnit]="units" [index]="index"></app-gauge>
        </div>
        <span
            class="operator" *ngIf="globalService.orderType=='app'">{{_listData &&  _listData['telco'] && _listData['telco'].length>0 ?_listData['telco'][0]:'All'}}</span>
            <span
            class="operator" *ngIf="globalService.orderType=='telco'">{{_listData &&  _listData['appName'] && _listData['appName'].length>0 ?_listData['appName'][0]:'All'}}</span>
        </div>
    <div class="card-bottom">
        <ul class="date-list">
            <li>
                <div class="list-icons">
                    <img src="assets/images/calendar.svg" alt=""></div>
              
                <span *ngIf="_listData && _listData.startDate && _listData.endDate ">{{(_listData && _listData.startDate?(_listData.startDate | dateformatter):'')}}
                    - {{(_listData && _listData.endDate?(_listData.endDate | dateformatter):'')}}</span>
                    <span *ngIf="((_listData && !_listData.startDate) || (_listData &&  !_listData.endDate)) ">All</span>
            </li>
            <li>
                <div class="list-icons"><img src="assets/images/internet.svg" alt=""></div>
                <span>{{_listData && _listData.networkTag && _listData.networkTag[0]?_listData.networkTag[0].substring(0,_listData.networkTag[0].lastIndexOf(" ") + 1)+' '+'Mbps' :'All'}}</span>
            </li>
        </ul>
    </div>
    <ul class="feature-listing" *ngIf="kpiValueListArray.length>0">
        <li *ngFor="let score of kpiValueListArray;">
            <span class="feature-title">{{score['name']}}</span>
            <span class="feature-title">{{score['value']?score['value'].toFixed(1):'-'}}</span>
        </li>
    </ul>
</div>